import styled from "styled-components";

const IconGroup = styled.div`
  & > * {
    margin: 0.2rem;
  }
`;

export default IconGroup;
